import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

const SwitchInput = ({ label, checked, onChange, name }) => {
    return (
        <FormControlLabel
            control={<Switch checked={checked} onChange={onChange} name={name} />}
            label={label}
        />
    );
};

export default SwitchInput;
